import styled from "styled-components"

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  pointer-events: none;
`

export default TitleContainer



// WEBPACK FOOTER //
// ./src/Kiosk/Shared/TitleContainer.js